<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Dect Handset" class="d-icon d-icon--dect-handset" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 2A1.5 1.5 0 0 1 4.5.5h3A1.5 1.5 0 0 1 9 2v8a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 3 10V2Zm5 3V2a.5.5 0 0 0-.5-.5h-3A.5.5 0 0 0 4 2v3h4ZM4 6h4v4a.5.5 0 0 1-.5.5h-3A.5.5 0 0 1 4 10V6Zm.793-3.5a.5.5 0 0 1 .5-.5h1.414a.5.5 0 0 1 0 1H5.293a.5.5 0 0 1-.5-.5Zm-.168 5a.5.5 0 0 1 .5-.5h.004a.5.5 0 0 1 .001 1h-.004a.5.5 0 0 1-.501-.5Zm1.75 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1h-.005a.5.5 0 0 1-.5-.5ZM4.625 9a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1h-.005a.5.5 0 0 1-.5-.5Zm1.75 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1h-.005a.5.5 0 0 1-.5-.5Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconDectHandset',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
